export default {
  setDob: (payload: string) => ({ type: 'verify/setDob', payload }) as const,
  setPhoneNumber: (payload: string) =>
    ({ type: 'verify/setPhoneNumber', payload }) as const,
  pushErrorAttempt: (payload: string) =>
    ({ type: 'verify/pushErrorAttempt', payload }) as const,
  setState: (payload?: undefined | 'checking' | 'success') =>
    ({ type: 'verify/setState', payload }) as const,
};
